import React, { Component } from 'react'
import uuid from 'uuid/v4'
import ModalSearch from './ModalSearch'

class Modal extends Component {
  componentWillReceiveProps (props) {
    if (this.props === props) return
    if (props.isOpen && props.onOpen && !this.props.isOpen) props.onOpen()
    window.addEventListener('keydown', e => e.keyCode === 27 && this.props.isOpen && this.props.close())
  }
  render () {
    return (
      <div className='modal fade in' style={{display: (this.props.isOpen ? 'block' : 'none')}}>
        <div className='modal-backdrop' onClick={e => this.props.close.call()}>
          <div className='modal-dialog' onClick={e => e.stopPropagation()}>
            <div className={'modal-content ' + (this.props.noOverflow && 'no-overflow')}>
              <div className='modal-header'>
                <button type='button' className='close' onClick={(e) => this.props.close.call()}><span>&times;</span></button>
                <h4 className='modal-title'>{this.props.icon && <i className={'fa fa-fw fa-' + this.props.icon} />} {this.props.title}</h4>
                <ModalSearch filter={this.props.filter} />
              </div>
              <div className='modal-body'>
                {this.props.children}
              </div>
              <div className='modal-footer'>
                {this.props.buttons && this.props.buttons.map((button) => {
                  if (button.hidden) return null
                  return (
                    <a key={uuid()} onClick={button.event} className='modal-button'>{button.text}</a>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default Modal



// WEBPACK FOOTER //
// ./src/components/basic/containers/Modal.js